import React, {useState, useEffect, useRef} from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import Tabs from '@components/Tabs';
import Swipeable from '@components/Swipeable';
import PreviewComponent from '../PreviewComponent';
import Loading from '@components/Loading';
import { useHistory } from 'react-router';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

const RecentDesigns:React.FC<IProps> = (props, state:IState) => {
  const history = useHistory();

  const handleViewAll = () => {
    if (props.value === "SHARED") history.push({pathname: '/shared-files'});
    else history.push({pathname: '/my-designs'});
  }
  
  return (
    <S.Root id="scroll-top">
      { props.isLookingForDesigns === false &&
        <S.ViewAllButton
          onClick={handleViewAll}
        >
          VIEW ALL
        </S.ViewAllButton>
      }
      <S.Title>
        My Designs
      </S.Title>
      <Tabs
        options={props.options}
        value={props.value}
        setValue={props.setValue}
        sizes={{tabWidth: 150, barWidth: 100}}
      />
      {
        props.loading ?
          <S.LoaderContainer>
            <Loading 
              id={"loading-designs"}
              containerStyle={{justifyContent: 'center'}}
            />
          </S.LoaderContainer> 
        :
          <S.SwipeableContainer>
            <Swipeable
              itemsLength={props.currentDesigns && props.currentDesigns.length > 0 ? props.currentDesigns.length : 0}
              itemWidth={246}
              topArrows={85}
            >
              <TransitionGroup className="group-list">
                {
                  props.currentDesigns && props.currentDesigns.length > 0 &&
                  props.currentDesigns.map((design: any, index: number) => {
                    return (
                      <CSSTransition key={design.id} timeout={600} classNames="item">
                        <PreviewComponent
                          id={`preview-component-${index}`}
                          key={index}
                          index={index}
                          item={design}
                          showMetadata={true}
                          onActions={props.onActions}
                        />
                      </CSSTransition>
                    )
                  })
                }
              </TransitionGroup>
            </Swipeable>
          </S.SwipeableContainer>
      }
    </S.Root >
  );
}

export default RecentDesigns;